const LS_KEY = {
    auth: "auth",
    phone: "phone",
    phonenumber: "phonenumber",
    loggedinuser: "loggedinuser",
    cart: "cart",
    cartDescription: "cartDescription",
    category_id: "category_id",
    category_name: "category_name",
    rfq: 'rfq',
    rfqID: 'rfqID',
    status: 'status'
};

//Store Data in local storage
const set = {
    auth: (data) => {
        localStorage.setItem(LS_KEY.auth, data);
    },
    phone: (data) => {
        localStorage.setItem(LS_KEY.phone, data);
    },
    phonenumber: (data) => {
        localStorage.setItem(LS_KEY.phonenumber, data);
    },
    loggedinuser: (data) => {
        localStorage.setItem(LS_KEY.loggedinuser, JSON.stringify(data));
    },
    category_id: (data) => {
        localStorage.setItem(LS_KEY.category_id, data);
    },
    category_name: (data) => {
        localStorage.setItem(LS_KEY.category_name, data);
    },
    cart: (data) => {
        localStorage.setItem(LS_KEY.cart, JSON.stringify(data));
    },
    cartDescription: (data) => {
        localStorage.setItem(LS_KEY.cartDescription, JSON.stringify(data));
    },
    rfq: (data) => {
        localStorage.setItem(LS_KEY.rfq, JSON.stringify(data));
    },
    rfqID: (data) => {
        localStorage.setItem(LS_KEY.rfqID, JSON.stringify(data));
    },
    status: (data) => {
        localStorage.setItem(LS_KEY.status, data);
    }
}

//Fetch Data from local storage
const fetch = {
    auth: () => {
        const data = localStorage.getItem(LS_KEY.auth);
        if (data) {
            try {
                const decoded = data;
                return decoded;
            } catch (err) { }
        }
    },
    phone: () => {
        const data = localStorage.getItem(LS_KEY.phone);
        if (data) {
            try {
                const decoded = data;
                return decoded;
            } catch (err) { }
        }
    },
    phonenumber: () => {
        const data = localStorage.getItem(LS_KEY.phonenumber);
        if (data) {
            try {
                const decoded = data;
                return decoded;
            } catch (err) { }
        }
    },
    loggedinuser: () => {
        const data = localStorage.getItem(LS_KEY.loggedinuser);
        if (data) {
            try {
                const decoded = JSON.parse(data);
                return decoded;
            } catch (err) { }
        }
    },
    cart: () => {
        const data = localStorage.getItem(LS_KEY.cart);
        if (data) {
            try {
                const decoded = JSON.parse(data);
                return decoded;
            } catch (err) { }
        }
    },
    cartDescription: () => {
        const data = localStorage.getItem(LS_KEY.cartDescription);
        if (data) {
            try {
                const decoded = JSON.parse(data);
                return decoded;
            } catch (err) { }
        }
    },
    rfq: () => {
        const data = localStorage.getItem(LS_KEY.rfq);
        if (data) {
            try {
                const decoded = JSON.parse(data);
                return decoded;
            } catch (err) { }
        }
    },
    rfqID: () => {
        const data = localStorage.getItem(LS_KEY.rfqID);
        if (data) {
            try {
                const decoded = JSON.parse(data);
                return decoded;
            } catch (err) { }
        }
    },
    category_name: () => {
        const data = localStorage.getItem(LS_KEY.category_name);
        if (data) {
            try {
                const decoded = data;
                return decoded;
            } catch (err) { }
        }
    },
    status: () => {
        const data = localStorage.getItem(LS_KEY.status);
        if (data) {
            try {
                const decoded = data;
                return decoded;
            } catch (err) { }
        }
    }
}

//Destory Data from local storage
const destory = {
    auth: () => {
        localStorage.removeItem(LS_KEY.auth);
    },
    phone: () => {
        localStorage.removeItem(LS_KEY.phone);
    },

    phonenumber: () => {
        localStorage.removeItem(LS_KEY.phonenumber);
    },
    loggedinuser: () => {
        localStorage.removeItem(LS_KEY.loggedinuser);
    },
    rfq: () => {
        localStorage.removeItem(LS_KEY.rfq);
    },
    rfqID: () => {
        localStorage.removeItem(LS_KEY.rfqID);
    },
};


export const storage = {
    set,
    fetch,
    destory,
};
